import { render, staticRenderFns } from "./ModalInformacaoTerritorio.vue?vue&type=template&id=aad3088a&lang=pug"
import script from "./ModalInformacaoTerritorio.vue?vue&type=script&lang=js"
export * from "./ModalInformacaoTerritorio.vue?vue&type=script&lang=js"
import style0 from "./ModalInformacaoTerritorio.vue?vue&type=style&index=0&id=aad3088a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports